<div class="wrapper">
  <!-- top navbar-->
  <app-payout-header class="topnavbar-wrapper" style="background-color: #D9D9D9 !important;"></app-payout-header>
  <!-- sidebar-->
  <app-payout-sidebar class="aside-container"></app-payout-sidebar>
  <!-- offsidebar-->
  
  <!-- Main section-->
  <section style="margin-left: 250px;">
    <!-- Page content-->
    <div class="content-wrapper" style=" padding-top: 60px;">
        <router-outlet></router-outlet>
    </div>
</section>
  <!-- Page footer-->
  <app-payout-footer class="footer-container" app-payout-footer></app-payout-footer>
</div>